import { FLEETS_FILTERS_SECTIONS } from './fleets-filters-sections';
import { PROJECTS_FILTERS_SECTIONS } from './projects-filters-sections';
import { TENDERS_INFO_FILTERS_SECTIONS } from './tenders-info-filters-sections';
import { TENDERS_NEW_FILTERS_SECTIONS } from './tenders-new-filters-sections';

export const FEATURE_FILTERS_SECTIONS = {
  projects: PROJECTS_FILTERS_SECTIONS,
  fleets: FLEETS_FILTERS_SECTIONS,
  tenders: TENDERS_NEW_FILTERS_SECTIONS,
  'tenders-info': TENDERS_NEW_FILTERS_SECTIONS,
};
